import { AlertTriangle, Eye, RefreshCw, Link2, Activity } from "lucide-react";

const TYPE_ICON = {
  "Single Point of Failure": AlertTriangle,
  "Potential Oversight": Eye,
  "Recovery Concern": RefreshCw,
  "Dependency Observation": Link2,
  "Operational Risk Emerging": Activity,
};

// We never use red in fonts. Severity is conveyed by the bar + chip background only.
const SEV_STYLES = {
  severe: { bar: "bg-red-600",   chip: "bg-red-100  dark:bg-red-500/20  text-slate-900 dark:text-slate-100 border-red-200  dark:border-red-500/30",  label: "Severe" },
  high:   { bar: "bg-red-500",   chip: "bg-red-50   dark:bg-red-500/15  text-slate-900 dark:text-slate-100 border-red-200  dark:border-red-500/30",  label: "High" },
  medium: { bar: "bg-amber-500", chip: "bg-amber-50 dark:bg-amber-400/15 text-slate-900 dark:text-slate-100 border-amber-200 dark:border-amber-400/30", label: "Medium" },
  low:    { bar: "bg-teal-600",  chip: "bg-teal-50  dark:bg-teal-400/15 text-slate-900 dark:text-slate-100 border-teal-200  dark:border-teal-400/30", label: "Low" },
};

export default function InsightCard({ insight, index = 0 }) {
  const Icon = TYPE_ICON[insight.type] || Activity;
  const sev = SEV_STYLES[insight.severity] || SEV_STYLES.low;

  return (
    <div
      data-testid={`insight-card-${index}`}
      className="animate-slide-in relative bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden hover:shadow-md hover:-translate-y-[1px] transition-all duration-200"
    >
      <div className={`absolute left-0 top-0 h-full w-1 ${sev.bar}`} />
      <div className="p-4 pl-5">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <Icon className="h-4 w-4 text-slate-500 dark:text-slate-400 shrink-0" strokeWidth={2} />
            <span className="text-[11px] uppercase tracking-[0.12em] text-slate-500 dark:text-slate-400 truncate">
              {insight.type}
            </span>
          </div>
          <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full border ${sev.chip}`}>
            {sev.label}
          </span>
        </div>
        <h4 className="mt-2 font-display text-[15px] font-semibold text-slate-900 dark:text-slate-50 leading-snug">
          {insight.title}
        </h4>
        <p className="mt-1.5 text-[13px] text-slate-600 dark:text-slate-300 leading-relaxed">{insight.body}</p>
      </div>
    </div>
  );
}
